module.exports = __webpack_public_path__ + "static/media/cq_sinistri b.b99f2bde.svg";